const generateTimeOptions = (): string[] => {
  const options: string[] = [];

  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += 15) {
      const period = hour < 12 ? 'am' : 'pm';
      const formattedHour = (hour % 12 === 0 ? 12 : hour % 12).toString();
      const formattedMinute = minute.toString().padStart(2, '0');
      const timeOption = `${formattedHour}:${formattedMinute} ${period}`;
      options.push(timeOption);
    }
  }

  return options;
};

export const timeOptions = generateTimeOptions();
